import { useEffect } from "react";
import { NotFoundWrapper } from "./styles/notfound.styled";
import { Link, useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate=useNavigate();
    useEffect(()=>{
        navigate("/404");
    },[])
    return (
        <NotFoundWrapper>
            <p>Sorry couldn't find the page you are looking for...</p>
            <p>Please click <Link to="/">here</Link> to get started.</p>
        </NotFoundWrapper>
    )
}
export default NotFound;